let language;
export const getLanguage = () => {
    if (language === '' || language === null || language === undefined) {
        language = document.querySelector('html').getAttribute('lang');
    }

    return language;
};
